import { render, staticRenderFns } from "./QuestionComment.vue?vue&type=template&id=6f0b77a1&lang=pug&"
import script from "./QuestionComment.vue?vue&type=script&lang=js&"
export * from "./QuestionComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports